var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
class IIMRunsService {
    static createIIMRun(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestBody = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                inspection_id: params.inspectionId,
                visibility: params.visibility,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                is_full_run: params.isFullRun
            };
            // Add is_trial parameter if provided
            if (params.isTrial !== undefined) {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                requestBody.is_trial = params.isTrial;
            }
            const response = yield api.post('/api/internal/iim_runs', requestBody);
            if (response.status !== 200) {
                throw new Error(`Failed to create IIM run: ${response.status}`);
            }
        });
    }
}
export default IIMRunsService;
